<template>
    <div class="loading-wrap">
        <img src="~@/assets/img/indicator-loading.gif" style="width: 10rem;">
    </div>
</template>

<script>
export default {
    name: "loading"
}
</script>

<style scoped>
.loading-wrap {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 6rem;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.2);
}
</style>
